var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegative({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_4001_9280)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3334 8.66667L8.66669 14.6667C8.13625 14.6667 7.62755 14.456 7.25247 14.0809C6.8774 13.7058 6.66669 13.1971 6.66669 12.6667V10H2.89335C2.70008 10.0022 2.50864 9.96233 2.33231 9.88319C2.15597 9.80405 1.99894 9.68751 1.87211 9.54166C1.74529 9.3958 1.65168 9.22412 1.59779 9.0385C1.5439 8.85288 1.53102 8.65776 1.56002 8.46667L2.48002 2.46667C2.52824 2.14873 2.68973 1.85893 2.93475 1.65066C3.17977 1.4424 3.4918 1.3297 3.81335 1.33333H11.3334M11.3334 8.66667V1.33333M11.3334 8.66667H13.1134C13.4907 8.67334 13.8573 8.54124 14.1436 8.29545C14.43 8.04966 14.6161 7.70729 14.6667 7.33333V2.66667C14.6161 2.29271 14.43 1.95033 14.1436 1.70455C13.8573 1.45876 13.4907 1.32666 13.1134 1.33333H11.3334",
    stroke: "#ACACBE",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4001_9280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.4b71d1fc6c2fe71b184a5b2ba9e4575a.svg";
export { ForwardRef as ReactComponent };